import { useMemo } from "react";

const RateButtons = ({ selectedOption, rateIndex, onSelect }) => {

    const ratesArray = useMemo(() => {
        return selectedOption.rateValues.map(rateValue => rateValue.rate);
    }, [selectedOption]);

    return (
        <>
            {ratesArray.map((value,index) => (
                <button key={index} 
                    className={`${rateIndex === index ? "btn" : "btn-flat"} waves-effect col s2`}
                    disabled={value.lessThan(-100)} 
                    onClick={() => onSelect(index)}>
                        <b>{value.toString()}%</b>
                </button>
            ))}
        </>
    )
};

export default RateButtons;